enum TranslationKeys {
  // Banner
  BannerTitle = "Heading.CookieBanner",
  CookieBannerContent = "Description.CookieBannerContent",
  CookieBannerButton = "Action.CookieBanner",
  PrivacyPolicy = "Description.PrivacyPolicy",

  // Modal
  ConsentToolModalTitle = "Heading.CookieSettings",
  SaveBtn = "Action.SavePreferences",
  CancelBtn = "Action.Cancel",

  // Information Collection
  InfoCollectionHeader = "Heading.InformationCollection",
  InfoCollectionContent = "Description.InformationCollection",
  InfoCollectionHeader2 = "Heading.InformationCollection2",
  InfoCollectionContent2 = "Description.InformationCollection2",
  InfoPartnerCollectionHeader = "Heading.InformationPartnerCollection",
  InfoPartnerCollectionContent = "Description.InformationPartnerCollection",

  // Cookie Types
  RBXViralAcquisition = "RBXViralAcquisition",
  RBXViralAcquisitionDescription = "Description.RBXViralAcquisition",
  RBXSource = "RBXSource",
  RBXSourceDescription = "Description.RBXSource",
  GoogleAnalytics = "Heading.GoogleAnalytics",

  // Labels
  OwnedBy = "Label.OwnedBy",
  GoogleInc = "Google Inc.",
  Website = "Label.Website",

  // Google Analytics
  GoogleAnalyticsPurposeHeader = "Heading.GoogleAnalyticsPurpose",
  GoogleAnalyticsPurposeDescription = "Description.GoogleAnalyticsPurpose",
  CompanyCollectionHeader = "Heading.CompanyCollection",
  DataCollected = "Label.DataCollected",
  DataCollectedContent = "Description.DataCollected",
  DataSharing = "Label.DataSharing",
  DataSharingContent = "Description.DataSharing",
  DataRetention = "Label.DataRetention",
  DataRetentionContent = "Description.DataRetention",
  DataUse = "Label.DataUse",
  DataUseContent = "Description.DataUse",
  DataStorage = "Label.DataStorage",
  DataStorageContent = "Description.Undisclosed",

  // Actions
  RequestData = "Action.RequestData",
  SetCookieOptions = "Action.SetCookieOptions",
  DeclineAll = "Action.DeclineAll",
  AcceptAll = "Action.AcceptAll",

  // Cookie Categories
  EssentialCookie = "Heading.EssentialCookies",
  AnalyticsCookie = "Heading.AnalyticsCookies",

  // Google Analytics Read More
  GAReadMore = "Description.GAReadMore",
  GAReadMoreUrl = "{googleAnalyticsLink}",
}

export default TranslationKeys;
